import React from 'react';
import { whatsappUrl, ATENDENTE_MSG } from '../../config';

// Botão flutuante de WhatsApp (canto inferior direito) — abre a conversa com o
// atendente já com a mensagem padrão. Número e mensagem vêm de src/config.js.
export default function FloatingWhatsApp({ message = ATENDENTE_MSG }) {
    return (
        <a
            href={whatsappUrl(message)}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Falar com o atendente no WhatsApp"
            title="Falar com o atendente no WhatsApp"
            className="fwa-btn"
            style={S.btn}
        >
            <style>{`
                @keyframes fwa-pulse { 0% { transform: scale(1); opacity: 0.5; } 70% { transform: scale(1.7); opacity: 0; } 100% { opacity: 0; } }
                .fwa-btn:hover { transform: scale(1.08); box-shadow: 0 10px 30px rgba(37,211,102,0.6) !important; }
            `}</style>
            <span style={S.pulse} />
            <svg width="32" height="32" viewBox="0 0 24 24" fill="#ffffff" xmlns="http://www.w3.org/2000/svg" style={{ position: 'relative', zIndex: 1 }}>
                <path d="M.057 24l1.687-6.163a11.867 11.867 0 0 1-1.587-5.946C.16 5.335 5.495 0 12.05 0a11.817 11.817 0 0 1 8.413 3.488 11.824 11.824 0 0 1 3.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 0 1-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.86 9.86 0 0 0 1.518 5.26l-.999 3.648 3.97-.617zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
            </svg>
        </a>
    );
}

const S = {
    btn: {
        position: 'fixed', right: 20, bottom: 20, zIndex: 1000,
        width: 58, height: 58, borderRadius: '50%',
        background: '#25D366',
        display: 'grid', placeItems: 'center',
        boxShadow: '0 8px 24px rgba(37,211,102,0.45)',
        cursor: 'pointer', textDecoration: 'none',
        transition: 'transform 0.18s ease, box-shadow 0.18s ease',
    },
    pulse: {
        position: 'absolute', inset: 0, borderRadius: '50%',
        background: '#25D366', opacity: 0.55,
        animation: 'fwa-pulse 2s ease-out infinite',
    },
};
